
const Constants = {
  PlayerStates: {
    Buffering: 'buffering',
    Idle: 'idle',
    Paused: 'paused',
    Playing: 'playing',
  },
};

const Content = {

  changeMultiChannel: (player, content) => {    // REVIEW TODO respetar tambien punto de reproduccion?
    const state = player.getState();
    const position = player.getPosition();
    // REVIEW TODO compatibilidad con playlist?, reemplazar solo el elemento actualmente reproduciendose?
    player.load([ content ]);   // REVIEW TOFIX que pasa si el componente raiz hace un re-render volviendo a pasar el playlist que tiene guardo en su state
    if( state ===  Constants.PlayerStates.Playing) {
      // REVIEW TODO si esta pausado a mitad de video poner la posicion en el lugar correcto, pero dejar en pausa, no si se puede hacer por que seek automaticamente produce play y no se otra forma de manipular posicion
      //    evaluar la posibilidad de usar startFrom
      player.seek( position);
    }
  },

};

export default Content;
